import { createContext, useState } from "react";
import { useCommonApi } from "./commonApi";
import Cookies from "js-cookie";


const CommonServiceContext = createContext();

const CommonService = ({ children }) => {
  const apiClient = useCommonApi();
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [cities, setCities] = useState([]);
  const [deliveryOrderTypes, setDeliveryOrderTypes] = useState([]);
  const [peymentMethods, setPeymentMethods] = useState([]);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [service, setService] = useState(null);
  const [faq, setFaq] = useState([]);
  const [terms, setTerms] = useState(null);
  const [officeLocations, setOfficeLocations] = useState([]);
  const [news, setNews] = useState([]);
  const [newsItem, setNewsItem] = useState(null);
  const [parcel, setParcel] = useState({});
  const [userFavoriteClients, setUserFavoriteClients] = useState([]);

  const clearOrder = () => {
    setOrder(null);
  };

  const checkToken = async () => {
    let token = Cookies.get("Token");
    //console.log(token);
    if (token) {
      try {
        setLoading(true);
        const response = await apiClient.get("/Users/CheckToken", {
          headers: { token: token },
        });
        setLoading(false);
        //console.log(response);
        if (response && response.data) {
          //console.log(response.data);
          if (!response.data.success) {
            Cookies.remove("Token");
          }
          return response.data.success;
        }

        return false;
      } catch (error) {
        Cookies.remove("Token");
        setErrors(error);
      }
    } else {
      Cookies.remove("Token");
      return false;
    }
  };

  // #region DeliveryOrders

  //download delivery order stiker by trackingNumber
  const downloadStickerByTrackingNumber = async (url) => {
    try {
      setLoading(true);

      const response = await apiClient.get(
        "DeliveryOrders/GetStickerByTrackingNumber" + url,
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const fileURL = window.URL.createObjectURL(blob);

      window.open(fileURL, "_blank");

      return true;
    } catch (error) {
      setErrors(error);

      return false;
    } finally {
      setLoading(false);
    }
  };
  // const downloadStickerByTrackingNumber = async (url) => {
  //   const ret = false;
  //   try {

  //     setLoading(true);

  //     await apiClient.get("DeliveryOrders/GetStickerByTrackingNumber" + url, {
  //       responseType: "blob", // important for binary files like PDFs
  //     })
  //       .then((response) => {

  //         const blob = new Blob([response.data], { type: "application/pdf" });

  //         const fileURL = window.URL.createObjectURL(blob);
  //         window.open(fileURL, "_blank");
  //         ret = true;
  //       })
  //       .catch((error) => {
  //         // console.log(error);
  //         setErrors(error);

  //       });

  //     setLoading(false);

  //   } catch (error) {
  //     setLoading(false);
  //     setErrors(error);

  //   }

  //   return ret;
  // };


  const trackOrder = async (postData) => {
    try {
      setLoading(true);

      const response = await apiClient.post(
        "/DeliveryOrders/TrackOrders",
        postData
      );

      setLoading(false);
      const { data } = response;

      if (data && data.success) {
        const { deliveryOrders } = data;
        if (deliveryOrders.length > 0) {
          setOrder(deliveryOrders[0]);
        }
      }

      return response;
    } catch (error) {
      setErrors(error);
    }
  };

  const addDeliveryOrder = async (postData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/DeliveryOrders/DeliveryOrderAdd",
        postData
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const addDeliveryOrder4User = async (postData) => {
    try {
      setLoading(true);
      const token = Cookies.get("Token");
      //console.log("Token in addDeliveryOrder4User:", token);
      const response = await apiClient.post(
        "/DeliveryOrders/DeliveryOrderAdd4User",
        postData,
        {
          headers: { token: token },
        }
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion DeliveryOrders



  const getAddresses = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Home/GetAddresses", {
        headers: { token: Cookies.get("Token") },
      });
      setLoading(false);
      if (response && response.data) {
        const { clientAddress } = response.data;
        setAddresses(clientAddress);
      }
      return response.data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const priceCalculation = async (postData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/DeliveryOrders/PriceCalculation",
        postData
      );
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  ///////Reffereces
  // #region References

  const getReferences = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/GetReferences");
      setLoading(false);
      if (response && response.data) {
        const citiesData = response.data.filter(
          (item) => item.key === "Cities"
        );
        setCities(citiesData);

        const orderTypes = response.data.filter(
          (item) => item.key === "DeliveryOrderTypes"
        );
        setDeliveryOrderTypes(orderTypes);

        const peymentMethodsData = response.data.filter(
          (item) => item.key === "PaymentMethods"
        );
        setPeymentMethods(peymentMethodsData);

        const deliveryMethodsData = response.data.filter(
          (item) => item.key === "DeliveryMethods"
        );
        setDeliveryMethods(deliveryMethodsData);

        const packageTypesData = response.data.filter(
          (item) => item.key === "PackageTypes"
        );
        setPackageTypes(packageTypesData);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getCities = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/GetReferences");
      setLoading(false);
      if (response && response.data) {
        const citiesData = response.data.filter(
          (item) => item.key === "Cities"
        );
        //console.log(citiesData);
        setCities(citiesData);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion References

  const askContract = async (postData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Pages/ContractRequest", postData);
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  ////////Pages
  // #region Pages
  const getHomePage = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/Home");
      if (response && response.data) {
        const { officeLocations, news } = response.data;
        setOfficeLocations(officeLocations);
        setNews(news);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getServiceList = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/ServicesList");
      if (response && response.data) {
        const { services } = response.data;
        setServiceList(services);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getService = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Pages/ServicesList/${id}`);
      if (response && response.data) {
        const { services } = response.data;
        setService(services[0]);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getFAQ = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/Faq");
      if (response && response.data) {
        const { contentList } = response.data;
        //console.log(contentList);
        setFaq(contentList);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getTerms = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/Terms");
      setLoading(false);

      if (response && response.data) {
        const { contentList } = response.data;
        if (contentList.length > 0) {
          setTerms(contentList[0]);
        }
      }

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getNewsById = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Pages/NewsList/${id}`);
      setLoading(false);
      if (response && response.data) {
        const { news } = response.data;
        setNewsItem(news[0]);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion Pages

  const searchParcel = async (postData) => {
    //1456331634
    try {
      setParcel({});
      setLoading(true);
      // const fData = {
      //   code: 1456331634,
      //   recaptchaCode: "SgeX860!",
      // };
      const response = await apiClient.post("/Wb/ParcelSearch", postData);
      if (response && response.data) {
        setParcel(response.data);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  //handle payment order creation and redirect
  const createPaymentOrder = async (paymentUrl) => {
    setLoading(true);

    try {
      const response = await apiClient.get(
        "Payment/createorder/" + paymentUrl
      );

      if (response.data.code === 0 && response.data.redirectUrl) {
        // Redirect to payment provider
        window.location.href = response.data.redirectUrl;
      } else {
        setErrors(response.data.message);
      }
      return response.data;
    } catch (error) {
      setErrors(error?.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadParcelInvoice = async (url) => {
    //1456331634
    try {

      setLoading(true);

      await apiClient.get("Wb/getinvoice/" + url, {
        responseType: "blob", // important for binary files like PDFs
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });

          const fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL, "_blank");
        })
        .catch((error) => {
          setErrors(error);
        });

      setLoading(false);

    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #region UserFavoriteClients

  const getUserFavoriteClients = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        "/UserFavorites/GetUserFavoriteClients",
        {
          headers: { token: Cookies.get("Token") },
        }
      );

      if (response && response.data) {
        setUserFavoriteClients(response.data);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  //#endregion

  const sendSms = async (formData) => {
    try {
      const response = await apiClient.post(
        "/DeliveryOrders/SmsPinRequest",
        formData
      );
      const { data } = response;

      return response;
    } catch (error) {
      setErrors(error);
    }
  };

  return (
    <CommonServiceContext.Provider
      value={{
        loading,
        errors,
        order,
        cities,
        deliveryOrderTypes,
        peymentMethods,
        deliveryMethods,
        packageTypes,
        addresses,
        serviceList,
        service,
        faq,
        terms,
        officeLocations,
        news,
        newsItem,
        parcel,
        userFavoriteClients,
        trackOrder,
        clearOrder,
        getCities,
        getReferences,
        checkToken,
        addDeliveryOrder,
        addDeliveryOrder4User,
        downloadStickerByTrackingNumber,
        getAddresses,
        priceCalculation,
        askContract,
        getServiceList,
        getService,
        getFAQ,
        getTerms,
        getHomePage,
        getNewsById,
        searchParcel,
        getUserFavoriteClients,
        sendSms,
        downloadParcelInvoice,
        createPaymentOrder
      }}
    >
      {children}
    </CommonServiceContext.Provider>
  );
};

export { CommonServiceContext, CommonService };
